module.exports = __webpack_public_path__ + "img/p3.10017249.png";